import validate from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}